import React from "react";

import ExecutingStageWaitingCustomerTimeCellContent from "../components/ExecutingStageWaitingCustomerTimeCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function executingStageWaitingCustomerTime({
	width,
	onResize,
}: Column.Options) {
	return base(
		ColumnId.ExecutingStageWaitingCustomerTime,
		(item) => <ExecutingStageWaitingCustomerTimeCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default executingStageWaitingCustomerTime;
